import FlowerText from './FlowerText/FlowerText';
export default FlowerText;